<template>
  <div>
    <b-card-group deck>
      <b-card title="Qr de usuario a buscar" class="text-uppercase text-center">
        <qrcode-reader v-if="mostrar" @decode="onDecode"></qrcode-reader>
      </b-card>
    </b-card-group>
  </div>
</template>
<script>
export default {
  name: "validate",
  components: {},
  data: function() {
    return {
      modalShow: true,
      selected: null,
      idSearch: "",
      mostrar: true
    };
  },
  methods: {
    setData: function(select) {
      console.log(select);
    },
    searchId: function() {
      console.log(this.idSearch);
      this.$store
        .dispatch("validateCredential", this.idSearch)
        .then(response => {
          console.log("respuesta", response);
        })
        .catch(err => {
          console.log("respuesta", err);
        });
    },
    onDecode: function(decode) {
      this.mostrar = false;
      if (decode.length > 2) {
        this.$store
          .dispatch("validateCredentialCode", decode)
          .then(response => {})
          .catch(error => {});
      } else {
        setTimeout(() => {
          this.mostrar = true;
        }, 200);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/admin/carnets/validate.vue